module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/plates_and_maps.htm#plates"
    }
  }, [_c('i', [_vm._v("List of Plates and Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword.htm#fore"
    }
  }, [_c('i', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction.htm#pct1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch1.htm#ct1"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("1 ")]), _vm._v("Virtue, Honour and Chastity")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch2.htm#ct2"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("2 ")]), _vm._v("Age of the Imperators: Cleopatra, Fulvia and Livia 44–31 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch3.htm#ct3"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("3 ")]), _vm._v("Women in the Augustan State: 31 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v("–"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 14")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch4.htm#ct4"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("4 ")]), _vm._v("Forging the Future: Livia, Octavia and Julia 27 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v("–"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 14")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch5.htm#ct5"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("5 ")]), _vm._v("The Dowager Empress and Matriarch: Livia 14–29")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch6.htm#ct6"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("6 ")]), _vm._v("Impatient for Equality: Agrippina the Elder 29–41")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch7.htm#ct7"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("7 ")]), _vm._v("Self-Destruction: Messalina 41–8")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch8.htm#ct8"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("8 ")]), _vm._v("The Reign of Agrippina the Younger: Part 1 49–54")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch9.htm#ct9"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("9 ")]), _vm._v("The Reign of Agrippina the Younger: Part 2 54–9")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch10.htm#ct10"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("10 ")]), _vm._v("Murder: Agrippina, Claudia Octavia and Poppaea 59–68")])]), _vm._v(" "), _c('p', {
    staticClass: "contents2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch11.htm#ct11"
    }
  }, [_c('span', {
    staticClass: "conblock"
  }, [_vm._v("11 ")]), _vm._v("Epilogue: The Severan and Other Empresses")])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/appendix_1.htm#app1"
    }
  }, [_c('i', [_vm._v("Appendix 1: Key Dates")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/appendix_2.htm#app2"
    }
  }, [_c('i', [_vm._v("Appendix 2: Family Trees")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/appendix_3.htm#app3"
    }
  }, [_c('i', [_vm._v("Appendix 3: Key Female Personalities")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/glossary.htm#gloss"
    }
  }, [_c('i', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#note"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/select_bibliography.htm#biblio"
    }
  }, [_c('i', [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#ind1"
    }
  }, [_c('i', [_vm._v("Index of Women")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#ind2"
    }
  }, [_c('i', [_vm._v("Index of Emperors")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-prect"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#ind3"
    }
  }, [_c('i', [_vm._v("General Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0